import React, { useContext } from 'react'
import NoteContext from '../context/note/NoteContext.js';

const NoteItem = (props) => {
    const context = useContext(NoteContext);
    const { deleteNote, backgroundColor, textColor } = context;
    const { notes, updateNote } = props;
    return (
        <div className='col-md-6 mb-2'>
            <div className="card shadow-sm border cards">
                {/* <img src="..." className="card-img-top" alt="..."/> */}
                <div className="card-body" style={{...backgroundColor, ...textColor}}>
                    <div className='d-flex align-items-center justify-content-between'>
                        <h5 className="card-title mb-0">Title: {notes.title}</h5>
                        <div>
                            <i
                                className="fa-regular fa-trash-can text-danger mx-2 cursor-pointer"
                                onClick={() => { deleteNote(notes._id); }}
                                aria-label="Delete Note"
                            ></i>
                            <i
                                className="fa-regular fa-pen-to-square mx-2 cursor-pointer"
                                onClick={() => { updateNote(notes); }}
                                aria-label="Edit Note"
                            ></i>
                        </div>
                    </div>
                    <p className="card-text" style={textColor}>Description: {notes.description}</p>
                    <p className="card-text" style={textColor}>Tag: {notes.tag}</p>
                    <p className="card-text" style={textColor}>Created At: {notes.timeStamp}</p>
                </div>
            </div>
        </div>

    )
}

export default NoteItem
